export default __webpack_public_path__ + "static/media/female.381c8bdb.png";